/* global workforceEnabledForEvent fetchUrl */

import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import KeyMetricsExpenditureSummary from './KeyMetricsExpenditureSummary';
import KeyMetricsKeyStatistics from './KeyMetricsKeyStatistics';
import KeyMetricsRevenueSummary from './KeyMetricsRevenueSummary';
import KeyMetricsWorkforceSummary from './KeyMetricsWorkforceSummary';

import { apiClient } from 'Helpers/network';

export default function KeyMetrics(props) {
    const [url, setUrl] = useState(props.fetchUrl);
    const [summaryExpenditure, setSummaryExpenditure] = useState({});
    const [summaryWorkforce, setSummaryWorkforce] = useState({});
    const [summaryKeyStatistics, setSummaryKeyStatistics] = useState({});
    const [summaryRevenue, setSummaryRevenue] = useState({});
    const [costcentresNumber, setCostcentresNumber] = useState(0);
    const [departmentsNumber, setDepartmentsNumber] = useState(0);
    const [fetched, setFetched] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = (link = null) => {
        apiClient
            .get(link || url)
            .then((response) => {
                const { numberCostcenters, numberDepartments, expenditureSummary, workforceSummary, keyStatisticsSummary, revenueSummary } = response.data;
                setSummaryExpenditure(expenditureSummary);
                setSummaryWorkforce(workforceSummary);
                setSummaryKeyStatistics(keyStatisticsSummary);
                setSummaryRevenue(revenueSummary);
                setDepartmentsNumber(numberDepartments);
                setCostcentresNumber(numberCostcenters);
            })
            .finally(() => {
                if (!fetched) {
                    setFetched(true);
                }
            });
    };

    return (
        <>
            {fetched && (
                <div className={'tw-flex max-lg:tw-flex-col tw-gap-3 tw-mt-3'}>
                    <div className={`${props.workforceEnabledForEvent ? 'tw-w-6/12' : 'tw-w-full'} max-lg:tw-w-full`}>
                        <KeyMetricsExpenditureSummary
                            departmentsNumber={departmentsNumber}
                            costcentresNumber={costcentresNumber}
                            summaryExpenditure={summaryExpenditure}
                        />
                    </div>
                    {!!props.workforceEnabledForEvent && (
                        <div className={'tw-w-6/12 max-lg:tw-w-full'}>
                            <KeyMetricsWorkforceSummary summaryWorkforce={summaryWorkforce} />
                        </div>
                    )}
                </div>
            )}
            {fetched && (
                <div className={'tw-flex tw-mt-3'}>
                    <div className={'tw-w-full'}>
                        <KeyMetricsKeyStatistics summaryKeyStatistics={summaryKeyStatistics} />
                    </div>
                </div>
            )}
            {fetched && (
                <div className={'tw-flex tw-mt-3'}>
                    <div className={'tw-w-full'}>
                        <KeyMetricsRevenueSummary summaryRevenue={summaryRevenue} />
                    </div>
                </div>
            )}
        </>
    );
}

if (document.getElementById('event-key-metrics')) {
    var rootEl = document.getElementById('event-key-metrics');
    ReactDOM.render(
        <App>
            <KeyMetrics workforceEnabledForEvent={workforceEnabledForEvent} fetchUrl={fetchUrl} />
        </App>,
        rootEl,
    );
}
